/**
 * Create a page for all wpPage nodes automatically via
 * filesystem routing: https://www.gatsbyjs.com/docs/reference/routing/file-system-route-api/
 */
import * as React from "react"
import { graphql } from "gatsby"
import MainLayout from "../layouts/main"
import formatTimeRange from "../utils/format-time-range"
import WordpressContent from "../components/wordpress-content"
import { json } from "body-parser"

interface IPageProps {
  data: Queries.WpEventPageQuery
}

export default function EventPage(props: IPageProps): JSX.Element {
  const event = props?.data?.wpEvent
  const breadcrumbs = JSON.stringify([
    {
      text: `Home`,
      url: `/`,
      id: 0,
    },
    {
      text: `Events`,
      url: `/news-events/all-events`,
      id: 1,
    },
    {
      text: event?.title,
      url: event?.uri,
      id: 2,
    },
  ])
  const timeString = formatTimeRange(
    event?.startTime?.replace(`:00`, ``).replace(`:`, ``) || ``,
    event?.endTime?.replace(`:00`, ``).replace(`:`, ``) || ``
  )

  // console.log(`{WpEvent.uri} page`, event) //Failed buiding the page for Event ID 261039.Updated event and trying to rebuid.

  const content = event?.content?.replace(/\[.*\]/gim, ``)
  let location = ``
  if (event?.location !== null && event?.location !== undefined) {
    const locationJason = JSON.parse(event?.location)
    location = locationJason.location_name
  }

  return (
    <MainLayout localMenuItem={null} breadcrumbs={breadcrumbs}>
      <div className="mainContent">
        <h1 className="text-4xl mb-4 text-blue">{event?.title}</h1>

        <div className="grid grid-cols-12">
          <div className="col-span-1 font-semibold">Date:</div>
          <div className="col-span-11">{event?.datestring}</div>
        </div>
        {location !== `` ? (
          <div className="grid grid-cols-12 ">
            <div className="col-span-1 font-semibold">Time:</div>
            <div className="col-span-11">{timeString}</div>
          </div>
        ) : (
          <div className="grid grid-cols-12 mb-4">
            <div className="col-span-1 font-semibold">Time:</div>
            <div className="col-span-11">{timeString}</div>
          </div>
        )}
        {location !== `` && (
          <div className="grid grid-cols-12 mb-4">
            <div className="col-span-1 font-semibold">Location:</div>
            <div className="col-span-11">{location}</div>
          </div>
        )}

        <WordpressContent html={content || ``} />
      </div>
    </MainLayout>
  )
}

export const Head = ({
  data,
}: {
  data: Queries.WpEventPageQuery
}): JSX.Element => (
  <>
    <meta key="PageID" name="PageID" content={data?.wpEvent?.databaseId} />
    <title id="page-title">
      {data?.wpEvent?.title} - Event | Georgian College
    </title>
  </>
)

// configure page, for example set defer to use DSG
// export async function config() {
//   // Optionally use GraphQL here
//   return ({ params }) => {
//     return {
//       defer: true,
//     }
//   }
// }

export const query = graphql`
  query WpEventPage($uri: String!) {
    wpEvent(uri: { eq: $uri }) {
      title
      content
      datestring
      endDatestring
      startTime
      endTime
      databaseId
      location
    }
  }
`
